module.exports = __webpack_public_path__ + "img/1x2game.9dffa088.png";